"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseTablesDisplayGrid = void 0;
const tslib_1 = require("tslib");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_core_1 = require("@tableau/catalog-core");
const TablesDisplayGrid_1 = require("../sharedDisplayGrid/TablesDisplayGrid");
function DatabaseTablesDisplayGrid(props) {
    const { publishedConnectionsLineageEnabled } = (0, catalog_core_1.useFeatureFlags)();
    const siteUrls = (0, catalog_core_1.useSiteUrls)();
    const cols = [
        (0, data_catalog_shared_1.createSelectionColumn)(),
        ...(0, TablesDisplayGrid_1.columns)(siteUrls)
            .map(columnFactory => columnFactory(props))
            .filter(column => {
            if (column.name === 'virtualConnections' && !publishedConnectionsLineageEnabled) {
                return false;
            }
            if (column.name === 'warning' || column.name === 'certification') {
                return false;
            }
            if (column.name === 'database') {
                return false;
            }
            return true;
        }),
    ];
    return (react_1.default.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.DatabaseTablesDisplayGrid = DatabaseTablesDisplayGrid;
//# sourceMappingURL=DatabaseTablesDisplayGrid.js.map